import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { Form, Button, FormGroup } from 'reactstrap';
import FormFooter from '../../../../common/forms/FormFooter';
import { isRequired } from '../../../../../utils/validators';
import CustomerInputGroup from '../../../../common/forms/CustomerInputGroup';
import FormItem from '../../../../common/forms/FormItem';
import Select from '../../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../../utils/enum';
import { CREDIT_NOTE_MOTIVES_TICKET } from '../../../../../config/constants';
import TextInput from '../../../../common/forms/input/TextInput';

const selector = formValueSelector('PasengerChangeForm');

const PasengerChangeForm = ({
  handleSubmit,
  onCancel,
  creditNoteMotiveValue,
}) => (
  <>
    <Form onSubmit={handleSubmit}>
      <CustomerInputGroup
        label="Nuevo Pasajero"
        name="customer"
        labelRequired
        form="PasengerChangeForm"
        validate={[isRequired]}
      />
      <FormGroup row>
        <FormItem label="Motivo de Cambio" required>
          <Field
            name="creditNoteMotive"
            component={Select}
            options={enumToSelectOptions(CREDIT_NOTE_MOTIVES_TICKET)}
            placeholder="Motivo de Cambio"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      {creditNoteMotiveValue &&
        creditNoteMotiveValue.value ===
          CREDIT_NOTE_MOTIVES_TICKET.OTHERS.value && (
          <FormGroup row>
            <FormItem label="Observación de Cambio" required>
              <Field
                name="creditNoteMotiveDescription"
                component={TextInput}
                type="textarea"
                placeholder="Observación de Cambio"
                validate={[isRequired]}
              />
            </FormItem>
          </FormGroup>
        )}
      <FormFooter saveButtonColor="secondary" saveButtonIcon={null}>
        <Button color="primary" onClick={onCancel}>
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  </>
);

PasengerChangeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  creditNoteMotiveValue: PropTypes.instanceOf(Object),
};

PasengerChangeForm.defaultProps = {
  creditNoteMotiveValue: null,
};

const mapStateToProps = (state) => ({
  creditNoteMotiveValue: selector(state, 'creditNoteMotive'),
});

const formComponent = reduxForm({
  form: 'PasengerChangeForm',
})(PasengerChangeForm);

export default connect(mapStateToProps, null)(formComponent);
